import { AppstoreOutlined, TeamOutlined, ClusterOutlined, HistoryOutlined } from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useAuth } from '_/contexts/AuthContext';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const appstoreIcon = <AppstoreOutlined />;
const teamIcon = <TeamOutlined />;
const clusterIcon = <ClusterOutlined />;
const historyIcon = <HistoryOutlined />;

export function useSuperAdminSidebarItems(): SidebarItem[] {
  const { isSuperAdmin } = useAuth();

  return useMemo(() => {
    const items: SidebarItem[] = [
      {
        icon: appstoreIcon,
        text: 'Organizations',
        href: '/orgs',
      },
    ];

    if (isSuperAdmin) {
      items.push(
        {
          icon: teamIcon,
          text: 'System Users',
          href: '/systemusers',
        },
        {
          icon: clusterIcon,
          text: 'Extraction Cells',
          href: '/extractioncells',
        },
        {
          icon: historyIcon,
          text: 'Recent Snapshots',
          href: '/recentsnapshots',
        },
      );
    }

    return items;
  }, [isSuperAdmin]);
}
